module.exports = __webpack_public_path__ + "img/ear.be5030ca.webp";